import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * PublicFooter — shared footer for all public marketing pages.
 * Renders the legal notice and contact email.
 */
export default function PublicFooter() {
    const { t } = useTranslation();
    return (
        <footer className="border-t border-border">
            <div className="max-w-5xl mx-auto px-4 sm:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-muted-foreground">
                <span>{t('landing.footer.legal')}</span>
                <a
                    href={`mailto:${t('landing.footer.contact')}`}
                    className="hover:text-foreground transition-colors"
                >
                    {t('landing.footer.contact')}
                </a>
            </div>
        </footer>
    );
}
